module.exports = __webpack_public_path__ + "static/img/10.152701e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/eng/10.png
// module id = YS+p
// module chunks = 0